module.exports = __webpack_public_path__ + "img/lunch_box.253c7f73.jpg";